import BottomNavigation from "components/BottomNavigation"
import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Nav,
  NavLink,
  Row,
  Col,
  TabContent,
  TabPane,
} from "reactstrap"
import {
  FormSection,
  getFormSyncErrors,
  initialize,
  reduxForm,
  setSubmitFailed,
} from "redux-form"
import {
  createSubCalendar,
  resetSubCalendar,
  updateSubCalendar,
} from "store/actions"
import AccessTab from "./accessTab"
import AvailabilityTab from "./availabilityTab"
import CommunicationTab from "./communicationTab"
import DetailsTab from "./detailsTab"
import PaymentTab from "./paymentTab"
import validate from "./subCalendarValidation"
import { mapApiToSubCalendarForm, mapSubCalendarFormToApi } from "./utils"

const moment = require("moment-timezone")

const SubCalendar = ({
  handleBack,
  selectedSubCalendar,
  initializeForm,
  resetSubCalendar,
  handleSubmit,
  selectedCalendarGroup,
  resetSelectedCalendarGroup,
  userId,
  vendorId,
  createSubCalendar,
  loading,
  updateSubCalendar,
  formSyncErrors,
  setSubTabBreadcrumb,
  allSubCalendars,
  setFormSubmitFailed,
}) => {
  const TABS = {
    DETAILS: 1,
    AVAILABILITY: 2,
    PAYMENT: 3,
    ACCESS: 4,
    COMMUNICATION: 5,
  }

  const [activeTab, setActiveTab] = useState(TABS.DETAILS)
  const [showInvalidFormModal, setShowInvalidFormModal] = useState(false)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    const items = [
      {
        title: selectedSubCalendar
          ? "Edit Sub Calendar"
          : "Create Sub Calendar",
        type: "tab",
        clickHandler: () => {
          setActiveTab(TABS.DETAILS)
        },
      },
    ]
    switch (activeTab) {
      case 1:
        items.push({ title: "Details" })
        break
      case 2:
        items.push({
          title: "Availability",
        })
        break
      case 3:
        items.push({ title: "Payment" })
        break
      case 4:
        items.push({ title: "Access" })
        break
      case 5:
        items.push({ title: "Communication" })
        break
      default:
        break
    }
    setSubTabBreadcrumb(items)
  }, [activeTab, selectedSubCalendar])

  useEffect(() => {
    if (selectedSubCalendar) {
      initializeForm(mapApiToSubCalendarForm(selectedSubCalendar))
    }
  }, [selectedSubCalendar])

  useEffect(() => {
    return () => {
      resetSubCalendar()
      resetSelectedCalendarGroup()
    }
  }, [])

  const handleSave = data => {
    if (!selectedSubCalendar) {
      createSubCalendar({
        ...mapSubCalendarFormToApi({
          ...data,
          calendar_id: selectedCalendarGroup?.id,
          business_unit_id: selectedCalendarGroup?.business_unit_id,
          user_id: userId,
          vendor_id: vendorId,
        }),
        order: allSubCalendars?.length + 1,
      })
    } else {
      updateSubCalendar({
        ...selectedSubCalendar,
        ...mapSubCalendarFormToApi({
          ...data,
          calendar_id: selectedSubCalendar?.calendar_id,
          business_unit_id: selectedSubCalendar?.business_unit_id,
          user_id: userId,
          vendor_id: vendorId,
        }),
      })
    }
  }

  const onSubmitFailed = () => {
    setShowInvalidFormModal(true)
    setFormSubmitFailed()
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody className="ms-5">
          <Row className="d-flex justify-content-between">
            <Col xs="auto">
              {selectedSubCalendar && (
                <h5 className="mt-1">
                  Edit Sub Calendar: {selectedSubCalendar?.name}
                </h5>
              )}
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Done"
                color="light"
                onClick={handleBack}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto">
              <Nav pills className="flex-column">
                <NavLink
                  className={markIfIsActive(TABS.DETAILS)}
                  onClick={() => setActiveTab(TABS.DETAILS)}
                  style={
                    activeTab === TABS.DETAILS
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Details</span>}
                </NavLink>
                <NavLink
                  className={markIfIsActive(TABS.AVAILABILITY)}
                  onClick={() => setActiveTab(TABS.AVAILABILITY)}
                  style={
                    activeTab === TABS.AVAILABILITY
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Availability</span>}
                </NavLink>
                {selectedCalendarGroup?.paid_services === 1 && (
                  <NavLink
                    className={markIfIsActive(TABS.PAYMENT)}
                    onClick={() => setActiveTab(TABS.PAYMENT)}
                    style={
                      activeTab === TABS.PAYMENT
                        ? {}
                        : { backgroundColor: "#eff2f7" }
                    }
                  >
                    {<span style={{ fontSize: "16px" }}>Payment</span>}
                  </NavLink>
                )}
                <NavLink
                  className={markIfIsActive(TABS.ACCESS)}
                  onClick={() => setActiveTab(TABS.ACCESS)}
                  style={
                    activeTab === TABS.ACCESS
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Access</span>}
                </NavLink>
                <NavLink
                  className={markIfIsActive(TABS.COMMUNICATION)}
                  onClick={() => setActiveTab(TABS.COMMUNICATION)}
                  style={
                    activeTab === TABS.COMMUNICATION
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Communication</span>}
                </NavLink>
              </Nav>
            </Col>
            <Col>
              <TabContent activeTab={activeTab}>
                <TabPane tabId={TABS.DETAILS}>
                  <FormSection name="details">
                    <DetailsTab
                      tabIsActive={activeTab === TABS.DETAILS}
                      handleSave={
                        Object?.keys(formSyncErrors)?.length > 0
                          ? onSubmitFailed
                          : handleSubmit(handleSave)
                      }
                    />
                  </FormSection>
                  <BottomNavigation
                    handleNext={() => setActiveTab(TABS.AVAILABILITY)}
                    handleSave={
                      Object?.keys(formSyncErrors)?.length > 0
                        ? onSubmitFailed
                        : handleSubmit(handleSave)
                    }
                    loading={loading}
                  />
                </TabPane>
                <TabPane tabId={TABS.AVAILABILITY}>
                  <FormSection name="availability">
                    <AvailabilityTab
                      tabIsActive={activeTab === TABS.AVAILABILITY}
                      handleSave={
                        Object?.keys(formSyncErrors)?.length > 0
                          ? onSubmitFailed
                          : handleSubmit(handleSave)
                      }
                    />
                  </FormSection>
                  <BottomNavigation
                    handleNext={() =>
                      setActiveTab(
                        selectedCalendarGroup?.paid_services === 1
                          ? TABS.PAYMENT
                          : TABS.ACCESS
                      )
                    }
                    handleBack={() => setActiveTab(TABS.DETAILS)}
                    handleSave={
                      Object?.keys(formSyncErrors)?.length > 0
                        ? onSubmitFailed
                        : handleSubmit(handleSave)
                    }
                    loading={loading}
                  />
                </TabPane>
                <TabPane tabId={TABS.PAYMENT}>
                  <FormSection name="payment">
                    <PaymentTab
                      tabIsActive={activeTab === TABS.PAYMENT}
                      handleSave={
                        Object?.keys(formSyncErrors)?.length > 0
                          ? onSubmitFailed
                          : handleSubmit(handleSave)
                      }
                    />
                  </FormSection>
                  <BottomNavigation
                    handleNext={() => setActiveTab(TABS.ACCESS)}
                    handleBack={() => setActiveTab(TABS.AVAILABILITY)}
                    handleSave={
                      Object?.keys(formSyncErrors)?.length > 0
                        ? onSubmitFailed
                        : handleSubmit(handleSave)
                    }
                    loading={loading}
                  />
                </TabPane>
                <TabPane tabId={TABS.ACCESS}>
                  <FormSection name="access">
                    <AccessTab
                      tabIsActive={activeTab === TABS.ACCESS}
                      handleSave={
                        Object?.keys(formSyncErrors)?.length > 0
                          ? onSubmitFailed
                          : handleSubmit(handleSave)
                      }
                    />
                  </FormSection>
                  <BottomNavigation
                    handleNext={() => setActiveTab(TABS.COMMUNICATION)}
                    handleBack={() =>
                      setActiveTab(
                        selectedCalendarGroup?.paid_services === 1
                          ? TABS.PAYMENT
                          : TABS.AVAILABILITY
                      )
                    }
                    handleSave={
                      Object?.keys(formSyncErrors)?.length > 0
                        ? onSubmitFailed
                        : handleSubmit(handleSave)
                    }
                    loading={loading}
                  />
                </TabPane>
                <TabPane tabId={TABS.COMMUNICATION}>
                  <FormSection name="communication">
                    <CommunicationTab
                      tabIsActive={activeTab === TABS.COMMUNICATION}
                      handleSave={
                        Object?.keys(formSyncErrors)?.length > 0
                          ? onSubmitFailed
                          : handleSubmit(handleSave)
                      }
                    />
                  </FormSection>
                  <BottomNavigation
                    handleBack={() => setActiveTab(TABS.ACCESS)}
                    handleSave={
                      Object?.keys(formSyncErrors)?.length > 0
                        ? onSubmitFailed
                        : handleSubmit(handleSave)
                    }
                    loading={loading}
                  />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ModalComponent
        open={showInvalidFormModal}
        onClose={() => setShowInvalidFormModal(false)}
      >
        <h5>Invalid form values</h5>
        <Row className="d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Cancel"
              color="danger"
              onClick={() => setShowInvalidFormModal(false)}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  selectedSubCalendar: state.BookingsFeature.selectedSubCalendar,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  loading: state.BookingsFeature.loading,
  formSyncErrors: getFormSyncErrors(FORM_NAMES.SUB_CALENDARS)(state),
  allSubCalendars: state.BookingsFeature.allSubCalendars,
})

const mapDispatchToProps = dispatch => ({
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.SUB_CALENDARS, values)),
  resetSubCalendar: () => dispatch(resetSubCalendar()),
  createSubCalendar: values => dispatch(createSubCalendar(values)),
  updateSubCalendar: values => dispatch(updateSubCalendar(values)),
  setFormSubmitFailed: values =>
    dispatch(setSubmitFailed(FORM_NAMES.SUB_CALENDARS, values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAMES.SUB_CALENDARS,
    validate: validate,
    initialValues: {
      details: {
        inAppNotes: "Notes",
        location: "1",
        timezone: moment.tz.guess(),
      },
      communication: {
        reminderNotifications: [
          { type: 1, time_period: 30 },
          { type: 2, time_period: 60 },
        ],
        emailConfirmation: "Thank you for booking. You are confirmed.",
      },
      availability: {
        sun: false,
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        duration: 60,
        attendees: 1,
        maxSeats: 1,
      },
    },
  })(SubCalendar)
)
